"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const HandoverScreenWrapper = styled_components_1.default.div `
  top: 0;
  width: 100%;
  padding: 16px;
  z-index: 1140;

  a {
    display: inline-block;
    img {
      display: block;
      width: 100%;
    }
  }
`;
const HandoverScreen = (props) => {
    const { appIds } = props;
    const appStoreLink = `https://apps.apple.com/app/id${appIds.itunes}`;
    const googleStoreLink = `https://play.google.com/store/apps/details?id=${appIds.android}`;
    return (react_1.default.createElement(HandoverScreenWrapper, null,
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12, dangerouslySetInnerHTML: {
                    __html: i18n_js_1.default.t("kids_club_download_our_app_body"),
                } }),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement("a", { href: appStoreLink, target: "_blank", rel: "noreferrer" },
                    react_1.default.createElement("img", { src: "/images/download_banner/app-store.svg", alt: "app-store" }))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement("a", { href: googleStoreLink, target: "_blank", rel: "noreferrer" },
                    react_1.default.createElement("img", { src: "/images/download_banner/google-play.svg", alt: "google-play" }))))));
};
const mapStoreToProps = (store) => ({
    appIds: store.getValue("appIds"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(HandoverScreen));
